import { atomWithStorage } from 'jotai/utils'
import { useAtomValue, useSetAtom } from 'jotai'
import { atom } from 'jotai'

const webviewContextAtom = atomWithStorage<{
  url: string
  title: string
  text: string
  screenshot: string
  favicon?: string
} | null>('webview-context', null)

const optimisticWebviewContextAtom = atom<{
  url: string
  title: string
  isLoading: boolean
} | null>(null)

const tempWebviewContextAtom = atom<{
  url: string
  title: string
  text: string
  screenshot: string
  favicon?: string
} | null>(null)

const isChatPageFocusedAtom = atom<boolean>(true)

export const useWebviewContext = () => useAtomValue(webviewContextAtom)
export const useSetWebviewContext = () => useSetAtom(webviewContextAtom)

export const useOptimisticWebviewContext = () => useAtomValue(optimisticWebviewContextAtom)
export const useSetOptimisticWebviewContext = () => useSetAtom(optimisticWebviewContextAtom)

export const useTempWebviewContext = () => useAtomValue(tempWebviewContextAtom)
export const useSetTempWebviewContext = () => useSetAtom(tempWebviewContextAtom)

export const useIsChatPageFocused = () => useAtomValue(isChatPageFocusedAtom)
export const useSetIsChatPageFocused = () => useSetAtom(isChatPageFocusedAtom)

export { webviewContextAtom, optimisticWebviewContextAtom }
